import React, { useState } from 'react';
import { Facebook, Instagram, Linkedin, Send, Mail, Phone, X } from 'lucide-react';
export function Footer() {
  const [activeModal, setActiveModal] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer id="footer" className="bg-[#0A5E5C] text-white pt-20 pb-10" data-id="element-119">
        <div className="container mx-auto px-4" data-id="element-120">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-121">
            {/* Brand Column */}
            <div className="lg:col-span-1" data-id="element-122">
              <div className="flex items-center gap-2 mb-6" data-id="element-123">
                <div className="w-8 h-8 bg-white/10 rounded-full flex items-center justify-center" data-id="element-124">
                  <span className="text-[#D4A843] font-serif font-bold text-lg" data-id="element-125">
                    FG
                  </span>
                </div>
                <span className="text-xl font-serif font-bold" data-id="element-126">
                  Fair Gaming Space
                </span>
              </div>
              <p className="text-white/70 text-sm leading-relaxed mb-6" data-id="element-127">
                We protect players' rights and promote the development of a fair
                gaming market in Ukraine. Join our community.
              </p>
              <div className="flex gap-4" data-id="element-128">
                <a href="https://www.facebook.com/share/14bkTnc99Km/?mibextid=wwXIfr" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-129">
                  <Facebook size={18} data-id="element-130" />
                </a>
                <a href="https://www.instagram.com/olenavodolazhko?igsh=bHJjNTRjcWwzb2dl" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-131">
                  <Instagram size={18} data-id="element-132" />
                </a>
                <a href="https://www.linkedin.com/in/olena-vodolazhko-372ab576?utm_source=share_via&utm_content=profile&utm_medium=member_ios" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-133">
                  <Linkedin size={18} data-id="element-134" />
                </a>
                <a href="https://t.me/prostirchesnoigry" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center hover:bg-[#D4A843] transition-colors" data-id="element-135">
                  <Send size={18} data-id="element-136" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div data-id="element-137">
              <h3 className="text-lg font-serif font-bold mb-6 text-[#D4A843]" data-id="element-138">
                Quick Links
              </h3>
              <ul className="space-y-3" data-id="element-139">
                {[{
                name: 'Home',
                target: 'hero'
              }, {
                name: 'About Us',
                target: 'founder'
              }, {
                name: 'Activities',
                target: 'activities'
              }, {
                name: 'News',
                target: 'news'
              }, {
                name: 'Contact',
                target: 'footer'
              }].map(item => <li key={item.name} data-id="element-140">
                    <button onClick={() => {
                  const el = document.getElementById(item.target);
                  if (el) {
                    const headerOffset = 80;
                    const elementPosition = el.getBoundingClientRect().top + window.scrollY;
                    window.scrollTo({
                      top: elementPosition - headerOffset,
                      behavior: 'smooth'
                    });
                  }
                }} className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-141">
                      <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-142" />
                      {item.name}
                    </button>
                  </li>)}
              </ul>
            </div>

            {/* Legal */}
            <div data-id="element-143">
              <h3 className="text-lg font-serif font-bold mb-6 text-[#D4A843]" data-id="element-144">
                Information
              </h3>
              <ul className="space-y-3" data-id="element-145">
                <li data-id="element-146">
                  <button onClick={() => setActiveModal('privacy')} className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-147">
                    <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-148" />
                    Privacy Policy
                  </button>
                </li>
                <li data-id="element-149">
                  <button onClick={() => setActiveModal('terms')} className="text-white/70 hover:text-white transition-colors text-sm flex items-center gap-2" data-id="element-150">
                    <span className="w-1 h-1 bg-[#D4A843] rounded-full" data-id="element-151" />
                    Terms of Use
                  </button>
                </li>
              </ul>
            </div>

            {/* Contact Info */}
            <div data-id="element-152">
              <h3 className="text-lg font-serif font-bold mb-6 text-[#D4A843]" data-id="element-153">
                Contact Information
              </h3>
              <ul className="space-y-4" data-id="element-154">
                <li className="flex items-start gap-3 text-white/70 text-sm" data-id="element-155">
                  <Mail size={18} className="text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-156" />
                  <span data-id="element-157">fgsukraine@gmail.com</span>
                </li>
                <li className="flex items-start gap-3 text-white/70 text-sm" data-id="element-158">
                  <Phone size={18} className="text-[#D4A843] flex-shrink-0 mt-0.5" data-id="element-159" />
                  <span data-id="element-160">+38 (067) 403 2026</span>
                </li>
              </ul>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/50" data-id="element-161">
            <p data-id="element-162">© 2024 Fair Gaming Space. All rights reserved.</p>
            <p data-id="element-163">Built with love for fair play</p>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      {activeModal === 'privacy' && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-164">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-165" />
          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-166">
            <div className="sticky top-0 bg-white rounded-t-xl border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10" data-id="element-167">
              <h3 className="text-xl font-serif font-bold text-[#0A5E5C]" data-id="element-168">
                Privacy Policy
              </h3>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" data-id="element-169">
                <X className="w-5 h-5" data-id="element-170" />
              </button>
            </div>
            <div className="p-6 md:p-8 space-y-6 text-gray-700 leading-relaxed text-sm" data-id="element-171">
              <div className="text-center mb-4" data-id="element-172">
                <h4 className="text-lg font-serif font-bold text-[#0A5E5C]" data-id="element-173">
                  COMPREHENSIVE PRIVACY AND DATA PROTECTION POLICY
                </h4>
                <p className="text-[#D4A843] font-medium mt-1" data-id="element-174">
                  NGO "Fair Gaming Space"
                </p>
                <p className="text-gray-500 text-xs mt-1" data-id="element-175">
                  Edition: 18 February 2026
                </p>
              </div>

              <div className="space-y-5" data-id="element-176">
                <div data-id="element-177">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-178">
                    1. General Provisions
                  </h5>
                  <p data-id="element-179">
                    This Policy defines the procedure for processing and
                    protecting personal data of NGO "Fair Gaming Space". The
                    Organization acts in accordance with the Law of Ukraine "On
                    Personal Data Protection", and also applies the principles
                    of GDPR and UK GDPR when interacting with residents of the
                    EU or the United Kingdom.
                  </p>
                </div>
                <div data-id="element-180">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-181">
                    2. Data Processing Principles
                  </h5>
                  <p data-id="element-182">
                    Processing is carried out on the principles of lawfulness,
                    transparency, purpose limitation, data minimization,
                    accuracy, storage limitation, and ensuring integrity and
                    confidentiality.
                  </p>
                </div>
                <div data-id="element-183">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-184">
                    3. Categories of Data
                  </h5>
                  <p data-id="element-185">
                    Name, email, organization, IP address, technical data,
                    responses to research questionnaires, as well as anonymized
                    or pseudonymized data.
                  </p>
                </div>
                <div data-id="element-186">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-187">
                    4. Legal Bases (GDPR Art. 6, 9)
                  </h5>
                  <p data-id="element-188">
                    Consent of the data subject; legitimate interest;
                    performance of statutory tasks; fulfillment of legal
                    obligations. Special categories of data are processed
                    exclusively on the basis of explicit consent and with
                    appropriate safeguards.
                  </p>
                </div>
                <div data-id="element-189">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-190">
                    5. International Data Transfers
                  </h5>
                  <p data-id="element-191">
                    When transferring data outside Ukraine or the EU, Standard
                    Contractual Clauses (SCC) or other legally provided
                    protection mechanisms are applied.
                  </p>
                </div>
                <div data-id="element-192">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-193">
                    6. Data Processing Agreement (DPA)
                  </h5>
                  <p data-id="element-194">
                    When engaging contractors (hosting, email services, CRM),
                    Data Processing Agreements (DPA) are concluded that
                    establish the processor's obligations regarding security and
                    confidentiality.
                  </p>
                </div>
                <div data-id="element-195">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-196">
                    7. Cookies Policy
                  </h5>
                  <p data-id="element-197">
                    The website uses mandatory, analytical, and functional
                    cookies. Users can manage their consent through the banner
                    or browser settings.
                  </p>
                </div>
                <div data-id="element-198">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-199">
                    8. Data Breach Response Procedure
                  </h5>
                  <p data-id="element-200">
                    In the event of a data security breach, the Organization
                    conducts an internal investigation, takes measures to
                    minimize risks, and notifies competent authorities and data
                    subjects within the timeframes prescribed by law.
                  </p>
                </div>
                <div data-id="element-201">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-202">
                    9. DPO Appointment
                  </h5>
                  <p data-id="element-203">
                    The Organization may appoint a Data Protection Officer who
                    monitors compliance with legislation and receives requests
                    from data subjects.
                  </p>
                </div>
                <div data-id="element-204">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-205">
                    10. Rights of Data Subjects
                  </h5>
                  <p data-id="element-206">
                    Right to access, rectification, erasure, restriction of
                    processing, data portability, withdrawal of consent, and
                    lodging a complaint with a supervisory authority.
                  </p>
                </div>
                <div data-id="element-207">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-208">
                    11. UK and US Compliance Block
                  </h5>
                  <p data-id="element-209">
                    When cooperating with UK or US grantors, the Organization
                    complies with UK GDPR, UK Data Protection Act, and ensures
                    compliance with international data security standards and
                    anti-corruption legislation (UK Bribery Act, FCPA).
                  </p>
                </div>
                <div data-id="element-210">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-211">
                    12. Retention Periods
                  </h5>
                  <p data-id="element-212">
                    Data is retained no longer than necessary to achieve the
                    purpose of processing and to fulfill legislative or grant
                    requirements.
                  </p>
                </div>
                <div data-id="element-213">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-214">
                    13. Policy Updates
                  </h5>
                  <p data-id="element-215">
                    The current version of the Policy is always published on the
                    official website.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>}

      {/* Terms of Use Modal */}
      {activeModal === 'terms' && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setActiveModal(null)} data-id="element-216">
          <div className="absolute inset-0 bg-black/50 backdrop-blur-sm" data-id="element-217" />
          <div className="relative bg-white rounded-xl shadow-2xl w-full max-w-2xl max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-218">
            <div className="sticky top-0 bg-white rounded-t-xl border-b border-gray-100 px-6 py-4 flex items-center justify-between z-10" data-id="element-219">
              <h3 className="text-xl font-serif font-bold text-[#0A5E5C]" data-id="element-220">
                Terms of Use
              </h3>
              <button onClick={() => setActiveModal(null)} className="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors" data-id="element-221">
                <X className="w-5 h-5" data-id="element-222" />
              </button>
            </div>
            <div className="p-6 md:p-8 space-y-6 text-gray-700 leading-relaxed text-sm" data-id="element-223">
              <div className="text-center mb-4" data-id="element-224">
                <h4 className="text-lg font-serif font-bold text-[#0A5E5C]" data-id="element-225">
                  TERMS OF USE
                </h4>
                <p className="text-[#D4A843] font-medium mt-1" data-id="element-226">
                  NGO "Fair Gaming Space"
                </p>
                <p className="text-gray-500 text-xs mt-1" data-id="element-227">
                  Edition: 18 February 2026
                </p>
              </div>

              <div className="space-y-5" data-id="element-228">
                <div data-id="element-229">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-230">
                    1. General Provisions
                  </h5>
                  <p data-id="element-231">
                    These Extended Terms of Use govern access to and use of the
                    website of the Non-Governmental Organization "Fair Gaming
                    Space" (hereinafter — the Organization). By using the Site,
                    the User confirms full agreement with these Terms. The
                    Organization reserves the right to amend the Terms without
                    prior notice.
                  </p>
                </div>
                <div data-id="element-232">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-233">
                    2. Independence and Non-Affiliation
                  </h5>
                  <p data-id="element-234">
                    The Organization is an independent non-profit entity. It
                    does not conduct gambling activities, is not affiliated with
                    gambling operators, does not receive affiliate fees, and
                    does not promote commercial services of operators.
                  </p>
                </div>
                <div data-id="element-235">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-236">
                    3. Research Integrity Clause
                  </h5>
                  <p data-id="element-237">
                    All research is conducted independently, in accordance with
                    the principles of academic integrity, methodological
                    transparency, and voluntary participation. Donors do not
                    influence research outcomes.
                  </p>
                </div>
                <div data-id="element-238">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-239">
                    4. Informational Nature of Materials
                  </h5>
                  <p data-id="element-240">
                    The Site's materials are informational, analytical, and
                    educational in nature. They do not constitute legal,
                    medical, or financial advice. The Organization is not liable
                    for decisions made by the User based on Site materials.
                  </p>
                </div>
                <div data-id="element-241">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-242">
                    5. Registration and Participation in Research
                  </h5>
                  <p data-id="element-243">
                    Users may register to receive news or participate in
                    research. Participation in research is voluntary and based
                    on the principle of informed consent.
                  </p>
                </div>
                <div data-id="element-244">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-245">
                    6. Donations and Financial Transparency
                  </h5>
                  <p data-id="element-246">
                    Voluntary contributions are non-refundable charitable
                    donations. The Organization ensures transparent financial
                    reporting and may undergo independent audits.
                  </p>
                </div>
                <div data-id="element-247">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-248">
                    7. Anti-Corruption and Sanctions Provisions
                  </h5>
                  <p data-id="element-249">
                    The Organization complies with Ukrainian legislation,
                    international anti-corruption standards, the UK Bribery Act,
                    and FCPA (in the case of international funding). Funds from
                    sanctioned individuals or entities are not accepted.
                  </p>
                </div>
                <div data-id="element-250">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-251">
                    8. Intellectual Property
                  </h5>
                  <p data-id="element-252">
                    All Site materials are protected by intellectual property
                    legislation. Commercial use without written permission is
                    prohibited.
                  </p>
                </div>
                <div data-id="element-253">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-254">
                    9. Personal Data Protection
                  </h5>
                  <p data-id="element-255">
                    Processing of personal data is carried out in accordance
                    with the Law of Ukraine "On Personal Data Protection" and
                    GDPR principles (in the case of international interaction).
                  </p>
                </div>
                <div data-id="element-256">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-257">
                    10. Limitation of Liability
                  </h5>
                  <p data-id="element-258">
                    The Organization does not guarantee uninterrupted operation
                    of the Site and is not liable for technical disruptions or
                    actions of third parties.
                  </p>
                </div>
                <div data-id="element-259">
                  <h5 className="font-bold text-[#0A5E5C] mb-1" data-id="element-260">
                    11. Applicable Law
                  </h5>
                  <p data-id="element-261">These Terms are governed by the legislation of Ukraine.</p>
                </div>
              </div>
            </div>
          </div>
        </div>}
    </>;
}